module.exports = __webpack_public_path__ + "static/img/7.50fc1ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/777/7.png
// module id = tz+6
// module chunks = 0